import React from 'react'

import '../styles/weeklywins.css'
import images from '../assets/images'

const WeeklyWins = () => {
  return (
    <>
      <div className="wklywins">
        <div className="hdr">
          <h2>Weekly <span>Wins</span></h2>
          <p>Real trades from our members, powered by Summit Capital Signals</p>
        </div>
        <div className="carousel">
          <ul>
            <li>
              <div className="win">
                <div className="img-bg">
                  <div className="img" style={{ backgroundImage: `url(${images.spltr})` }}></div>
                  <p>$PLTR</p>
                </div>
                <div className="deets">
                  <div className="name">
                    <h3>$SPTR</h3>
                    <p>AI SIGNAL - LONG POSITION</p>
                  </div>
                  <div className="stk">
                    <div className="lft">
                      <p>ENTRY</p>
                      <h4>$49.85</h4>
                    </div>
                    <div className="ryt">
                      <p>EXIT</p>
                      <h4>$70.77</h4>
                    </div>
                  </div>
                  <div className="prfts">
                    <div className="lft">
                      <p>PROFITS</p>
                      <h4>+$13,574</h4>
                    </div>
                    <div className="ryt">
                      <p>MEMBER</p>
                      <h4>@yvvz</h4>
                    </div>
                  </div>
                  <div className="cmmts">
                    <p>"pinged me right at open. waited for the pullback, got in clean and just let it breathe. honestly one of the easiest holds i've had in months"</p>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div className="win">
                <div className="img-bg">
                  <div className="img" style={{ backgroundImage: `url(${images.sethusd})` }}></div>
                  <p>$ETH/USD</p>
                </div>
                <div className="deets">
                  <div className="name">
                    <h3>$ETH/USD</h3>
                    <p>AI SIGNAL - SWING TRADE</p>
                  </div>
                  <div className="stk">
                    <div className="lft">
                      <p>ENTRY</p>
                      <h4>$2,552.47</h4>
                    </div>
                    <div className="ryt">
                      <p>EXIT</p>
                      <h4>$3,600.59</h4>
                    </div>
                  </div>
                  <div className="prfts">
                    <div className="lft">
                      <p>PROFITS</p>
                      <h4>+$26,305</h4>
                    </div>
                    <div className="ryt">
                      <p>MEMBER</p>
                      <h4>@testisatchel</h4>
                    </div>
                  </div>
                  <div className="cmmts">
                    <p>"got the alert sunday night, set my levels and went to sleep. woke up tuesday to +41%. didn't touch it once the whole time"</p>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div className="win">
                <div className="img-bg">
                  <div className="img" style={{ backgroundImage: `url(${images.stsla})` }}></div>
                  <p>$TSLA</p>
                </div>
                <div className="deets">
                  <div className="name">
                    <h3>$TSLA</h3>
                    <p>AI SIGNAL - CALL OPTIONS</p>
                  </div>
                  <div className="stk">
                    <div className="lft">
                      <p>ENTRY</p>
                      <h4>$274.35</h4>
                    </div>
                    <div className="ryt">
                      <p>EXIT</p>
                      <h4>$346.70</h4>
                    </div>
                  </div>
                  <div className="prfts">
                    <div className="lft">
                      <p>PROFITS</p>
                      <h4>+$13,900</h4>
                    </div>
                    <div className="ryt">
                      <p>MEMBER</p>
                      <h4>@c00wpaw</h4>
                    </div>
                  </div>
                  <div className="cmmts">
                    <p>"signal hit right before the move started. grabbed calls, didn't overthink it. first target printed in under an hour, was almost boring"</p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <ul aria-hidden>
            <li>
              <div className="win">
                <div className="img-bg">
                  <div className="img" style={{ backgroundImage: `url(${images.spltr})` }}></div>
                  <p>$PLTR</p>
                </div>
                <div className="deets">
                  <div className="name">
                    <h3>$SPTR</h3>
                    <p>AI SIGNAL - LONG POSITION</p>
                  </div>
                  <div className="stk">
                    <div className="lft">
                      <p>ENTRY</p>
                      <h4>$49.85</h4>
                    </div>
                    <div className="ryt">
                      <p>EXIT</p>
                      <h4>$70.77</h4>
                    </div>
                  </div>
                  <div className="prfts">
                    <div className="lft">
                      <p>PROFITS</p>
                      <h4>+$13,574</h4>
                    </div>
                    <div className="ryt">
                      <p>MEMBER</p>
                      <h4>@yvvz</h4>
                    </div>
                  </div>
                  <div className="cmmts">
                    <p>"pinged me right at open. waited for the pullback, got in clean and just let it breathe. honestly one of the easiest holds i've had in months"</p>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div className="win">
                <div className="img-bg">
                  <div className="img" style={{ backgroundImage: `url(${images.sethusd})` }}></div>
                  <p>$ETH/USD</p>
                </div>
                <div className="deets">
                  <div className="name">
                    <h3>$ETH/USD</h3>
                    <p>AI SIGNAL - SWING TRADE</p>
                  </div>
                  <div className="stk">
                    <div className="lft">
                      <p>ENTRY</p>
                      <h4>$2,552.47</h4>
                    </div>
                    <div className="ryt">
                      <p>EXIT</p>
                      <h4>$3,600.59</h4>
                    </div>
                  </div>
                  <div className="prfts">
                    <div className="lft">
                      <p>PROFITS</p>
                      <h4>+$26,305</h4>
                    </div>
                    <div className="ryt">
                      <p>MEMBER</p>
                      <h4>@testisatchel</h4>
                    </div>
                  </div>
                  <div className="cmmts">
                    <p>"got the alert sunday night, set my levels and went to sleep. woke up tuesday to +41%. didn't touch it once the whole time"</p>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div className="win">
                <div className="img-bg">
                  <div className="img" style={{ backgroundImage: `url(${images.stsla})` }}></div>
                  <p>$TSLA</p>
                </div>
                <div className="deets">
                  <div className="name">
                    <h3>$TSLA</h3>
                    <p>AI SIGNAL - CALL OPTIONS</p>
                  </div>
                  <div className="stk">
                    <div className="lft">
                      <p>ENTRY</p>
                      <h4>$274.35</h4>
                    </div>
                    <div className="ryt">
                      <p>EXIT</p>
                      <h4>$346.70</h4>
                    </div>
                  </div>
                  <div className="prfts">
                    <div className="lft">
                      <p>PROFITS</p>
                      <h4>+$13,900</h4>
                    </div>
                    <div className="ryt">
                      <p>MEMBER</p>
                      <h4>@c00wpaw</h4>
                    </div>
                  </div>
                  <div className="cmmts">
                    <p>"signal hit right before the move started. grabbed calls, didn't overthink it. first target printed in under an hour, was almost boring"</p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="carousel">
          <ul>
            <li>
              <div className="win">
                <div className="img-bg">
                  <div className="img" style={{ backgroundImage: `url(${images.shood})` }}></div>
                  <p>$HOOD</p>
                </div>
                <div className="deets">
                  <div className="name">
                    <h3>$HOOD</h3>
                    <p>AI SIGNAL - PUT OPTIONS</p>
                  </div>
                  <div className="stk">
                    <div className="lft">
                      <p>ENTRY</p>
                      <h4>$48.53</h4>
                    </div>
                    <div className="ryt">
                      <p>EXIT</p>
                      <h4>$62.05</h4>
                    </div>
                  </div>
                  <div className="prfts">
                    <div className="lft">
                      <p>PROFITS</p>
                      <h4>+$17,267</h4>
                    </div>
                    <div className="ryt">
                      <p>MEMBER</p>
                      <h4>@chop</h4>
                    </div>
                  </div>
                  <div className="cmmts">
                    <p>"was watching this anyway but couldn't nail the timing. signal gave me the green light and i just held the whole move down, easy"</p>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div className="win">
                <div className="img-bg">
                  <div className="img" style={{ backgroundImage: `url(${images.snvda})` }}></div>
                  <p>$NVDA</p>
                </div>
                <div className="deets">
                  <div className="name">
                    <h3>$NVDA</h3>
                    <p>AI SIGNAL - SCALP TRADE</p>
                  </div>
                  <div className="stk">
                    <div className="lft">
                      <p>ENTRY</p>
                      <h4>$121.38</h4>
                    </div>
                    <div className="ryt">
                      <p>EXIT</p>
                      <h4>$135.00</h4>
                    </div>
                  </div>
                  <div className="prfts">
                    <div className="lft">
                      <p>PROFITS</p>
                      <h4>+$13,540</h4>
                    </div>
                    <div className="ryt">
                      <p>MEMBER</p>
                      <h4>@cws</h4>
                    </div>
                  </div>
                  <div className="cmmts">
                    <p>"in and out in 45 mins. hit tp1 before most people even knew it was moving. clean signal, clean exit"</p>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div className="win">
                <div className="img-bg">
                  <div className="img" style={{ backgroundImage: `url(${images.spy})` }}></div>
                  <p>$SPY</p>
                </div>
                <div className="deets">
                  <div className="name">
                    <h3>$SPY</h3>
                    <p>AI SIGNAL - MOMENTUM PLAY</p>
                  </div>
                  <div className="stk">
                    <div className="lft">
                      <p>ENTRY</p>
                      <h4>$512.22</h4>
                    </div>
                    <div className="ryt">
                      <p>EXIT</p>
                      <h4>$546.50</h4>
                    </div>
                  </div>
                  <div className="prfts">
                    <div className="lft">
                      <p>PROFITS</p>
                      <h4>+$17,364</h4>
                    </div>
                    <div className="ryt">
                      <p>MEMBER</p>
                      <h4>@astrwicks</h4>
                    </div>
                  </div>
                  <div className="cmmts">
                    <p>"just followed the plan, didn't overthink it. signal had the entry and target laid out, i rode it the whole way and closed at target"</p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <ul aria-hidden>
            <li>
              <div className="win">
                <div className="img-bg">
                  <div className="img" style={{ backgroundImage: `url(${images.shood})` }}></div>
                  <p>$HOOD</p>
                </div>
                <div className="deets">
                  <div className="name">
                    <h3>$HOOD</h3>
                    <p>AI SIGNAL - PUT OPTIONS</p>
                  </div>
                  <div className="stk">
                    <div className="lft">
                      <p>ENTRY</p>
                      <h4>$48.53</h4>
                    </div>
                    <div className="ryt">
                      <p>EXIT</p>
                      <h4>$62.05</h4>
                    </div>
                  </div>
                  <div className="prfts">
                    <div className="lft">
                      <p>PROFITS</p>
                      <h4>+$17,267</h4>
                    </div>
                    <div className="ryt">
                      <p>MEMBER</p>
                      <h4>@chop</h4>
                    </div>
                  </div>
                  <div className="cmmts">
                    <p>"was watching this anyway but couldn't nail the timing. signal gave me the green light and i just held the whole move down, easy"</p>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div className="win">
                <div className="img-bg">
                  <div className="img" style={{ backgroundImage: `url(${images.snvda})` }}></div>
                  <p>$NVDA</p>
                </div>
                <div className="deets">
                  <div className="name">
                    <h3>$NVDA</h3>
                    <p>AI SIGNAL - SCALP TRADE</p>
                  </div>
                  <div className="stk">
                    <div className="lft">
                      <p>ENTRY</p>
                      <h4>$121.38</h4>
                    </div>
                    <div className="ryt">
                      <p>EXIT</p>
                      <h4>$135.00</h4>
                    </div>
                  </div>
                  <div className="prfts">
                    <div className="lft">
                      <p>PROFITS</p>
                      <h4>+$13,540</h4>
                    </div>
                    <div className="ryt">
                      <p>MEMBER</p>
                      <h4>@cws</h4>
                    </div>
                  </div>
                  <div className="cmmts">
                    <p>"in and out in 45 mins. hit tp1 before most people even knew it was moving. clean signal, clean exit"</p>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div className="win">
                <div className="img-bg">
                  <div className="img" style={{ backgroundImage: `url(${images.spy})` }}></div>
                  <p>$SPY</p>
                </div>
                <div className="deets">
                  <div className="name">
                    <h3>$SPY</h3>
                    <p>AI SIGNAL - MOMENTUM PLAY</p>
                  </div>
                  <div className="stk">
                    <div className="lft">
                      <p>ENTRY</p>
                      <h4>$512.22</h4>
                    </div>
                    <div className="ryt">
                      <p>EXIT</p>
                      <h4>$546.50</h4>
                    </div>
                  </div>
                  <div className="prfts">
                    <div className="lft">
                      <p>PROFITS</p>
                      <h4>+$17,364</h4>
                    </div>
                    <div className="ryt">
                      <p>MEMBER</p>
                      <h4>@astrwicks</h4>
                    </div>
                  </div>
                  <div className="cmmts">
                    <p>"just followed the plan, didn't overthink it. signal had the entry and target laid out, i rode it the whole way and closed at target"</p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}

export default WeeklyWins